import * as React from 'react'

import { Box, Chevron, Text, Touchable, useToggle } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export interface Props {
  label: string
  extensionFeatureHasConditions: boolean
}

const SubcategoryField = ({
  label,
  extensionFeatureHasConditions,
  children,
}: React.PropsWithChildren<Props>) => {
  const [open, toggle] = useToggle(false)

  const translations: Record<string, string> = {
    employeePersonalInfo: i18n.t('automations.subcategories.employee_personal_info'),
    employeeAddress: i18n.t('automations.subcategories.employee_address'),
    employeeIdAndBank: i18n.t('automations.subcategories.employee_id_and_bank'),
    employeeCompanyDetails: i18n.t('automations.subcategories.employee_company_details'),
    officeDetails: i18n.t('automations.subcategories.office_details'),
    documents: i18n.t('automations.subcategories.documents'),
    expenses: i18n.t('automations.subcategories.expenses'),
    timeOff: i18n.t('automations.subcategories.time_off'),
    legalEntity: i18n.t('automations.subcategories.legal_entity'),
    customFields: i18n.t('automations.subcategories.custom_fields'),
    contract: i18n.t('automations.subcategories.contract'),
    costCenterMemberships: i18n.t('automations.subcategories.cost_center_memberships'),
  }

  const getHeaderTranslation = () => {
    if (extensionFeatureHasConditions) {
      return label
    } else {
      return translations[label]
    }
  }

  const renderHeader = () => {
    const type = open ? 'radical' : 'primary'
    const direction = open ? 'up' : 'down'

    return (
      <Box paddingY="s8" paddingX="s16" cursor="pointer">
        <Touchable onClick={toggle(!open)}>
          <Box flexDirection="row" gap="s6" textAlign="left">
            <Box paddingTop="s4">
              <Chevron type={type} direction={direction} />
            </Box>
            <Text size="300" weight="semibold" color={open ? 'grey1000' : 'grey800'}>
              {getHeaderTranslation()}
            </Text>
          </Box>
        </Touchable>
      </Box>
    )
  }

  return (
    <>
      {renderHeader()}
      {open && (
        <Box background="grey100" paddingY="s16" paddingX="s32" gap="s8">
          {children}
        </Box>
      )}
    </>
  )
}

export default SubcategoryField
